import React, { useState, useEffect } from "react";
import { axios } from "@/utils";

import { FlexDiv } from "../../../../components/Atoms";
import YoutubeIframe from "@/components/Organisms/YoutubeIframe";
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";
import WebinarVideoOverlay from "./WebinarVideoOverlay";

import { StyledWebinarCard, TextBox, YoutubeContainer } from "./style";
import DoctorDetails from "./DoctorDetails";

function WebinarCard({
  id,
  title,
  date,
  time,
  // thumbnail,
  channelLogo,
  // videoDuration,
  videoUrl,
  buttonText,
  doctorList,
  startTime,
  endTime,
  onShowModalClick,
  isRegisteredUser,
  isWebinarRecordingsPage,
}) {
  const [thumbnail, setThumbnail] = useState("");
  const [showOverlay, setShowOverlay] = useState(true);
  const [videoStartTime, setVideoStartTime] = useState(startTime);
  const [videoEndTime, setVideoEndTime] = useState(
    isWebinarRecordingsPage ? startTime + 60 : endTime
  );
  const [videoId, setVideoId] = useState("");

  useEffect(() => {
    if (videoUrl) {
      const youtubeIDParser = (url) => {
        const regExp =
          /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return match && match[7].length === 11 ? match[7] : false;
      };

      const _videoId = youtubeIDParser(videoUrl);
      setVideoId(_videoId);

      const url = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${_videoId}&format=json`;
      axios.get(url).then((res) => {
        setThumbnail(res?.thumbnail_url);
      });
    }
  }, [videoUrl]);

  useEffect(() => {
    if (isRegisteredUser) {
      setVideoEndTime("");
      setShowOverlay(true);
    }
  }, [isRegisteredUser]);

  return (
    <StyledWebinarCard>
      <YoutubeContainer>
        {showOverlay ? (
          <WebinarVideoOverlay
            thumbnail={thumbnail}
            channelLogo={channelLogo}
            videoTitle={title}
            buttonText={buttonText}
            onCLickHandler={() => setShowOverlay(false)}
            // videoDuration={videoDuration}
            date={date}
          />
        ) : (
          <YoutubeIframe
            videoId={videoId}
            startTime={videoStartTime}
            endTime={videoEndTime}
            callBack={() => setShowOverlay(true)}
            showControls={isRegisteredUser}
            videoEndCallback={() =>
              isRegisteredUser
                ? {}
                : onShowModalClick({
                    type: isWebinarRecordingsPage
                      ? "WATCH_RECORDED_WEBINAR_REQUEST"
                      : "WATCH_WEBINAR_REQUEST",
                    oneTimeSession: id,
                  })
            }
          />
        )}
      </YoutubeContainer>
      <TextBox flex="1">
        <Typography
          mb="8px"
          color={theme.colorsV2.primary.shade_800}
          variant="heading5"
          flex="1"
        >
          {title}
        </Typography>
        <FlexDiv mb="24px">
          <Typography
            color={theme.colorsV2.gray.shade_500}
            variant="label2"
            mr="16px"
          >
            {date}
          </Typography>
          <Typography color={theme.colorsV2.gray.shade_500} variant="label2">
            {time}
          </Typography>
        </FlexDiv>
        <DoctorDetails doctorList={doctorList} />
      </TextBox>
    </StyledWebinarCard>
  );
}

WebinarCard.propTypes = {};

WebinarCard.defaultProps = {};

export default WebinarCard;
